type LoadingGifProps = {
  width?: number;
  height?: number;
};

export const LoadingGif: React.FC<LoadingGifProps> = ({
  width = 60,
  height = 60
}) => {
  return (
    <img
      src="/Loading-400x400.gif"
      alt="Loading"
      style={{ width, height, objectFit: 'contain' }}
      onError={(e) => {
        e.currentTarget.style.display = 'none';
      }}
    />
  );
};
